import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FrameIn } from 'projects/shared/src/interfaces/frame-in.interface';
import { FrameOutResponse } from 'projects/shared/src/interfaces/frame-out-response.interface';
import { Observable } from 'rxjs';
import { ShHeadersService } from '../headers/sh-headers.service';
import listAlertError from 'projects/shared/src/JSON/listAlertModal.json';
import { statusResponde } from 'projects/shared/src/public-api';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { SetGTM } from 'projects/shared/src/interfaces/interfaces';

@Injectable({
  providedIn: 'root',
})
export class ShSharedMicrosService {
  constructor(
    private http: HttpClient,
    private _shSharedHeaders: ShHeadersService,
    private gtmService: GoogleTagManagerService
  ) {}

  shGetActivityTypes(
    request: FrameIn,
    url: string,
    envHeaders: any
  ): Observable<FrameOutResponse> {
    let headers = this._shSharedHeaders.buildHeaders(request, envHeaders);
    headers = headers.set('id', '1');
    return this.http.get<FrameOutResponse>(`${url}`, {
      headers,
    });
  }

  shGetListAlertError() {
    return listAlertError;
  }

  searchAlert(pCode: string) {
    return listAlertError.find((item: any) => item.code == pCode);
  }

  builsContentAlert(pData: any, codeNotReponse?: string) {
    let dataContent: any = {};
    if (
      pData.status?.toString() &&
      statusResponde.STATUS.includes(pData.status)
    ) {
      dataContent = this.searchAlert(`${codeNotReponse}-${pData.status}`);
      dataContent.code = `${codeNotReponse}-${pData.status}`;
    } else {
      if (pData.error) {
        dataContent = pData.error;
      } else {
        dataContent = pData;
      }
    }

    return dataContent;
  }

  builsContentAlertMsj(pCode: any) {
    let dataContent: any = {};
    dataContent = this.searchAlert(pCode.toString());
    return dataContent;
  }

  modalMsj(data: any, typeModal: string, title: string, event: string) {
    let alertcontent = {
      title: title,
      nameButtonOK: 'Entendido',
      nameButtonCancel: 'Cancelar',
      alert: typeModal,
      request: '',
      dataError: {},
    };

    alertcontent.request = event || '';
    alertcontent.dataError = this.builsContentAlertMsj(data);

    return alertcontent;
  }

  setTagGTM(pSetGTM: SetGTM) {
    this.gtmService.pushTag(pSetGTM);
    console.log(`Evento enviado a GTM ${pSetGTM?.event}:`, pSetGTM);
  }
}
